import { toastService } from '@thefarmersfront/kitchen';

import { useAPI, useAsyncHandler } from '~/hooks/common';

import { TOAST_MESSAGE, type TypePickupShippingType } from '~/constants';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePatchOwnerSupplierShippingParams } from '~/types/vender.types';

const usePatchOwnerSupplierShipping = () => {
  const { runAsync } = useAsyncHandler();

  const patchOwnerSupplierShipping = useAPI<TypePatchOwnerSupplierShippingParams>({
    endpoint: '/api-owner/owner-supplier',
    method: 'patch',
  });

  const updateOwnerSupplierShipping = async (
    {
      ownerSupplierCode,
      shippingType,
      params,
    }: {
      ownerSupplierCode: string;
      shippingType: TypePickupShippingType;
      params: TypePatchOwnerSupplierShippingParams;
    },
    { onSuccess, onError }: { onSuccess?: () => void; onError?: () => void } = {}
  ) => {
    runAsync(
      () => patchOwnerSupplierShipping({ params, pathParams: `/${ownerSupplierCode}/shipping/${shippingType}` }),
      {
        onSuccess,
        onError: (error) => {
          toastService.addToast({
            type: 'error',
            message: (error as TypeErrorResponseData['error'])?.message || TOAST_MESSAGE.DEFAULT_ERROR,
          });
          onError?.();
        },
      }
    );
  };

  return { updateOwnerSupplierShipping };
};

export default usePatchOwnerSupplierShipping;
